export default {
  listSocialSecurityGroup: [],
  socialSecurityGroup: {
    ativo: true,
    id: 0,
    nome: '',
  },
}
